package com.yendo.mx.repository

import com.yendo.mx.models.DireccionGuardada
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.firestore
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.catch

object DireccionesRepository {
    private val db = Firebase.firestore
    private val auth = Firebase.auth

    /**
     * Escucha en tiempo real todas las direcciones del usuario actual.
     */
    fun observarMisDirecciones(): Flow<List<DireccionGuardada>> {
        val userId = auth.currentUser?.uid ?: return flowOf(emptyList())

        return db.collection("Usuarios")
            .document(userId)
            .collection("Direcciones")
            .snapshots
            .map { snapshot ->
                snapshot.documents.map { doc ->
                    // Mapeamos los datos y nos aseguramos de inyectar el ID del documento
                    doc.data<DireccionGuardada>().copy(id = doc.id)
                }
            }
            .catch { emit(emptyList()) }
    }

    /**
     * Crea o actualiza una dirección en la subcolección del usuario.
     */
    suspend fun guardarDireccion(direccion: DireccionGuardada) {
        val userId = auth.currentUser?.uid ?: return

        // 🚀 Lógica Dinámica:
        // Si ya tiene ID, apuntamos a ese documento para sobreescribir (Update).
        // Si no tiene ID, generamos una referencia nueva con ID aleatorio (Create).
        val docRef = if (direccion.id.isNotEmpty()) {
            db.collection("Usuarios")
                .document(userId)
                .collection("Direcciones")
                .document(direccion.id)
        } else {
            db.collection("Usuarios")
                .document(userId)
                .collection("Direcciones")
                .document // Genera un ID nuevo automáticamente
        }

        // Guardamos el objeto completo, asegurándonos de que el campo 'id'
        // dentro del objeto coincida con el nombre del documento en Firestore.
        docRef.set(direccion.copy(id = docRef.id))
    }

    /**
     * Elimina físicamente una dirección de la subcolección del usuario.
     */
    suspend fun eliminarDireccion(idDireccion: String) {
        val userId = auth.currentUser?.uid ?: return

        if (idDireccion.isEmpty()) return

        try {
            db.collection("Usuarios")
                .document(userId)
                .collection("Direcciones")
                .document(idDireccion)
                .delete()

            println("YENDO_DEBUG: Dirección eliminada exitosamente: $idDireccion")
        } catch (e: Exception) {
            println("YENDO_ERROR: No se pudo eliminar la dirección: ${e.message}")
        }
    }
}